export default __webpack_public_path__ + "static/media/vc-commingsoon.aca72583.svg";